import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";

// Constantes
const API_URL = process.env.REACT_APP_API_KEY;
const GASOLINE_BASE_URL = `${API_URL}/administracion/gasoline`;

/**
 * Muestra un mensaje de error usando SweetAlert2
 */
const showErrorAlert = (message, error = null) => {
    if (process.env.NODE_ENV === 'development' && error) {
        console.error('Error details:', error);
    }

    return Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message,
        confirmButtonText: 'Entendido'
    });
};

/**
 * Muestra un mensaje de éxito usando SweetAlert2
 */
const showSuccessAlert = (message, timer = 1500) => {
    return Swal.fire({
        icon: 'success',
        title: message,
        showConfirmButton: false,
        timer
    });
};

/**
 * Obtiene la lista de proveedores
 */
export const getProveedores = async (setProveedores) => {
    try {
        const { data } = await api.get(`${GASOLINE_BASE_URL}/getProveedores`);

        if (!data || !Array.isArray(data)) {
            throw new Error('Formato de datos inválido');
        }

        setProveedores(data);
        return data;
    } catch (error) {
        const errorMessage = error?.response?.data?.message ||
            'Error al obtener la lista de proveedores';

        await showErrorAlert(errorMessage, error);
        setProveedores([]);
        throw error;
    }
};

/**
 * Obtiene los tickets de un proveedor a partir de un XML
 */
export const buscarProveedorPeticion = async ({
                                                  proveedorId,
                                                  fechaInicio,
                                                  fechaFin,
                                                  xmlFile,
                                              }) => {
    // Validaciones de entrada
    if (!xmlFile) {
        throw new Error('Archivo XML requerido');
    }

    if (!proveedorId) {
        throw new Error('ID de proveedor requerido');
    }

    if (!fechaInicio || !fechaFin) {
        throw new Error('Las fechas de inicio y fin son requeridas');
    }

    try {
        const formData = new FormData();
        formData.append('file', xmlFile);

        const { data } = await api.post(
            `${GASOLINE_BASE_URL}/getTickets`,
            formData,
            {
                params: {
                    id: proveedorId,
                    fecha_inicio: fechaInicio,
                    fecha_fin: fechaFin,
                },
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );

        // Validar estructura de respuesta
        if (!data || typeof data !== 'object') {
            throw new Error('Formato de respuesta inválido del servidor');
        }

        return data;
    } catch (error) {
        const errorMessage = error?.response?.data?.message ||
            error?.message ||
            'Error al buscar los tickets del proveedor';

        throw new Error(errorMessage);
    }
};

/**
 * Actualiza el estado de validación de un ticket
 */
export const actualizarstatusValidate = async (
    id,
    status,
    setDatatable,
    id_proveedor,
    fecha_inicio,
    fecha_fin,
    setTotal,
    setSelectCheck,
    selectCheck,
    xmlFile
) => {
    // Validaciones
    if (!id) {
        await showErrorAlert('ID de ticket requerido');
        return;
    }

    try {
        await api.put(
            `${GASOLINE_BASE_URL}/updateStatusValidate`,
            null,
            {
                params: { id, status }
            }
        );

        // Recargar datos después de la actualización
        await buscarProveedorPeticion({
            proveedorId: id_proveedor,
            fechaInicio: fecha_inicio,
            fechaFin: fecha_fin,
            xmlFile
        });

        setSelectCheck(!selectCheck);

        await showSuccessAlert('Estado actualizado correctamente');
    } catch (error) {
        const errorMessage = error?.response?.data?.message ||
            'Error al actualizar el estado de validación';

        await showErrorAlert(errorMessage, error);
        throw error;
    }
};

/**
 * Sube la información de combustible a Odoo
 */
export const subirInformacioCombustible = async (data) => {
    // Validación de datos
    if (!data || typeof data !== 'object') {
        await showErrorAlert('Datos inválidos para enviar');
        return;
    }

    // Validar campos requeridos
    const requiredFields = [
        'id_proveedor',
        'fecha_compra',
        'fecha_captura',
        'fecha_inicio',
        'fecha_fin',
        'total'
    ];

    const missingFields = requiredFields.filter(field => !data[field]);

    if (missingFields.length > 0) {
        await showErrorAlert(
            `Faltan campos requeridos: ${missingFields.join(', ')}`
        );
        return;
    }

    try {
        const response = await api.post(
            `${GASOLINE_BASE_URL}/sendTicketsToPay`,
            data
        );

        await showSuccessAlert('Datos transferidos a Odoo correctamente');

        // Habilitar botón de Odoo si existe
        const botonOdoo = document.getElementById("botonOddu");
        if (botonOdoo) {
            botonOdoo.disabled = false;
        }

        return response.data;
    } catch (error) {
        const errorMessage = error?.response?.data?.message ||
            'Error al transferir los datos a Odoo';

        await showErrorAlert(errorMessage, error);
        throw error;
    }
};

/**
 * Obtiene las órdenes de compra en un rango de fechas
 */
export const getPurchaseOrder = async (setPurchaseDataTable, inicio, fin) => {
    // Validaciones
    if (!inicio || !fin) {
        await showErrorAlert('Las fechas de inicio y fin son requeridas');
        setPurchaseDataTable([]);
        return;
    }

    try {
        const { data } = await api.get(
            `${GASOLINE_BASE_URL}/getPurchaseOrder`,
            {
                params: {
                    fecha_inicio: inicio,
                    fecha_fin: fin
                }
            }
        );

        if (!Array.isArray(data)) {
            throw new Error('Formato de respuesta inválido');
        }

        setPurchaseDataTable(data);
        return data;
    } catch (error) {
        const errorMessage = error?.response?.data?.message ||
            'Error al obtener las órdenes de compra';

        await showErrorAlert(errorMessage, error);
        setPurchaseDataTable([]);
        throw error;
    }
};
